module.exports = __webpack_public_path__ + "static/media/header_provider.509de6ec.jpg";